import * as React from 'react'
function SvgSecurity(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M33.235 11.53c-3.294 0-8.555-2.65-12.047-5.271a1.875 1.875 0 00-2.259 0c-3.491 2.62-8.753 5.27-12.047 5.27-1.039 0-1.882.842-1.882 1.883 0 10.51 5.084 18.479 14.317 22.436a1.882 1.882 0 001.483 0c9.233-3.957 14.318-11.925 14.318-22.436 0-1.041-.844-1.883-1.883-1.883zM20.06 32.054V20.94H9.924a22.658 22.658 0 01-1.108-5.822c3.629-.612 7.922-2.752 11.243-5.039v10.861h10.134c-1.652 4.958-5.063 8.74-10.134 11.114z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgSecurity
